var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',_vm._l((_vm.photoGroups),function(photoGroup,index){return _c('b-list-group-item',{key:index,class:{ active: _vm.isActive(photoGroup) },attrs:{"href":_vm.href(photoGroup)}},[_vm._v(_vm._s(photoGroup.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }